// extracted by mini-css-extract-plugin
module.exports = {"root":"Stroke_root__paHZq","noMargin":"Stroke_noMargin__c10qj","fillContainer":"Stroke_fillContainer__0710b"};